// extracted by mini-css-extract-plugin
export default {"container":"ForwarderData_container__mvBZM"};